module.exports = __webpack_public_path__ + "static/media/Elon Musk.f7a3544b.jpg";